var exports = {
  "kL": "xa15a2ab7--cb6a28--container",
  "wx": "xa15a2ab7--cb6a28--header",
  "iW": "xa15a2ab7--cb6a28--main",
  "RR": "xa15a2ab7--cb6a28--listing",
  "tp": "xa15a2ab7--cb6a28--table",
  "x": "xa15a2ab7--cb6a28--offer",
  "Ir": "xa15a2ab7--cb6a28--sc_info",
};

module.exports = exports;
